import { Cell } from 'react-table';

export enum DocumentStatus {
  PUBLISHED   = 'PUBLISHED',
  DRAFT = 'DRAFT',
}

export type Document = {
  id?: string;
  uuid?: string;
  name: string;
  type?: string;
  typeId?: string;
  ownerId?: string;
  patientId?: string;
  uploaded?: string;
  data?: string;
  url?: string;
  status?: DocumentStatus;
};

export type Alert = {
  header: string;
  message: string;
  buttonPrimaryText?: string;
  primaryAction?: () => void;
  buttonSecondaryText?: string;
  secondaryAction?: () => void;
};

export type PdfType = {
  value: string;
  label: string;
};

type Patient = {
  firstname: string;
  lastname: string;
};

export type DocumentPreviewProps = {
  document: Document | null;
  patient: Patient;
  onClose: () => void;
  typeOptions?: { value: string; label: string }[];
};

export type InputProps = {
  cell: Cell;
  isAPreviewDocument: boolean;
};

export type ButtonWrapperProps = {
  justifyContent?: string;
};

export type DocumentResponse = {
  url: string;
};
export type DocumentType = {
  data: {
    getDocumentContent: Document;
  };
};

export type DocumentProps = {
  isLoading: boolean;
  patient: Patient;
  data: Document[];
  onUploadDocument?: (pdf: Document) => void;
  onDeleteDocument?: (id: string | null) => void;
  disabledUploading?: boolean;
  enableViewDocButton?: boolean;
  enableDeleteDocButton?: boolean;
  enableDownloadDocButton?: boolean;
  fetchDocument?: (documentId: string) => Promise<unknown>;
};